import React from 'react';
import Divider from 'material-ui/Divider'
import SubmitModal from 'components/modals/SubmitModal'
import FormLink from './FormLink';
import FormPageSchedule from './FormPageSchedule'
import FontIcon from 'material-ui/FontIcon';
import { updateObject } from 'helpers/objectHelpers';
import { withState, compose } from 'recompose';
import { isEmpty, last } from 'lodash'
import { removeItemArrayByIndex, updateItemArrayByIndex, addItemToArray } from 'helpers/arrayHelpers'
import CustomFlatButton from 'components/Button/CustomFlatButton'
import muiThemeable from 'material-ui/styles/muiThemeable'

const styles = {
  formLink: {
    width: '20%',
    margin: 20,
    paddingRight: 20,
    display: 'flex',
    flexDirection: 'column',
    borderRight: 'solid 1px lightgrey',
  },
  formLinkWrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  currentPage: {
    color: 'darkgrey',
  },
  pageSchedule: {
    width: '65%',
    margin: 20,
  },
  button: {
    paddingTop: 25,
    paddingLeft: 40,
  },
  addButton: {
    border: '1px dashed rgba(0, 0, 0, 0.3)',
    magin: 'auto',
    width: '100%',
    color: 'rgba(0, 0, 0, 0.3)',
    lineHeight: '14px',
  },
  addButtonIcon: {
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.3)',
    lineHeight: '14px',
  },
  deleteButton: {
    marginTop: 20,
    width: '15%',
    textAlign: 'center',
    lineHeight: '14px',
  },
  deleteButtonIcon: {
    fontSize: '14px',
    lineHeight: '14px',
  },
  scheduleTitle: {
    display: 'flex',
  },
  deleteTitle: {
    width: '5%',
  },
  startTitle: {
    width: '29%',
    color: 'grey',
    paddingLeft: 2,
  },
  endTitle: {
    width: '28%',
    color: 'grey',
  },
  selectPageTitle: {
    width: '38%',
    color: 'grey',
  },
  page: {
    paddingRight: 3,
    paddingTop: 27,
    fontSize: 16,
    color: 'lightGrey',
  },
};

const FormLinkPage = compose(
  muiThemeable(),
  withState('openModal', 'setOpenModal', false),
)(({
  linkPage,
  pages,
  onSubmit,
  valuePage,
  isEditing,
  setEditing,
  onRemove,
  openModal,
  setOpenModal,
  hideError,
  muiTheme,
}) => {
  const updateLinkPage = ({ value, key }) => onSubmit(updateObject(linkPage, { [key]: value }))

  const handlePageScheduleChange = (val, index) => {
    updateLinkPage({ value: updateItemArrayByIndex(linkPage.pageSchedule, index, () => val), key: 'pageSchedule' })
  }

  const handleRemovePageSchedule = (index) => {
    const result = removeItemArrayByIndex(linkPage.pageSchedule, index)
    return updateLinkPage({ value: result, key: 'pageSchedule' })
  }

  const getCurrentPage = () => {
    const currentDate = new Date()
    const matchedPages = linkPage.pageSchedule.filter((item) => (item.start <= currentDate.getTime() && currentDate.getTime() <= item.end))
    if (isEmpty(matchedPages)) {
      return ''
    }
    matchedPages.sort((a, b) => (
      a.start - b.start
    ))
    return last(matchedPages).pageId
  }
  return (
    <div style={{ display: 'flex', textAlign: 'left' }}>
      <div style={styles.formLink}>
        <div style={styles.formLinkWrapper}>
          <div style={styles.page}>
            page/
          </div>
          <FormLink
            value={linkPage.link}
            disabled={!isEditing}
            onChange={(value) => {
              updateLinkPage({ value, key: 'link' })
              hideError()
            }}
          />
        </div>
        <div style={styles.currentPage}>
          Current Page:{' '}
          {
            !isEmpty(getCurrentPage()) ?
              <span style={{ color: muiTheme.palette.accent1Color }}>{getCurrentPage()}</span>
              :
              'None'
          }

        </div>
      </div>
      <div style={styles.pageSchedule}>
        <div style={styles.scheduleTitle}>
          <small style={styles.deleteTitle} />
          <small style={styles.startTitle}>Start</small>
          <small style={styles.endTitle}>End</small>
          <small style={styles.selectPageTitle}>Select Page</small>
        </div>
        { linkPage.pageSchedule && linkPage.pageSchedule.length > 0 &&
          linkPage.pageSchedule.map((item, i) => (
            <FormPageSchedule
              index={i}
              hasEnd
              schedule={item}
              valuePage={valuePage}
              isEditing={isEditing}
              setEditing={setEditing}
              onSubmit={onSubmit}
              pages={pages}
              handlePageScheduleChange={(value) => handlePageScheduleChange(value, i)}
              onRemove={() => handleRemovePageSchedule(i)}
              hideError={hideError}
            />
          ))
        }
        <CustomFlatButton
          style={styles.addButton}
          label="Add Schedule"
          onTouchTap={() => {
            updateLinkPage({ value: addItemToArray(linkPage.pageSchedule, {}), key: 'pageSchedule' })
            setEditing(true)
            hideError()
          }}
          icon={
            <FontIcon
              className="fa fa-plus"
              color="black"
              style={styles.addButtonIcon}
            />
          }
        />
      </div>
      <SubmitModal
        open={openModal}
        deleteContent={'link'}
        onClose={() => { setOpenModal(false) }}
        onSubmit={() => {
          onRemove()
          setOpenModal(false)
          hideError()
        }}
      />
      <div style={styles.deleteButton}>
        <CustomFlatButton
          backgroundColor="black"
          white
          label="Delete"
          onTouchTap={() => setOpenModal(true)}
          icon={
            <FontIcon
              className="fa fa-trash"
              color="white"
              style={styles.deleteButtonIcon}
            />
          }
        />
      </div>
      <Divider />
    </div>
  );
});

FormLinkPage.propTypes = {};
FormLinkPage.defaultProps = {
  linkPage: { link: '', pageId: '' },
  pages: [],
  onChange: () => {},
  hideError: () => {},
};

export default FormLinkPage;



// WEBPACK FOOTER //
// ./src/components/forms/FormLinkPage.js